import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL/index'
import SystemProcesses from 'components/Modals/RiskSystemProcessesModal'
import SystemProcessesPageAPI from 'containers/SystemProcesses/Table/layers/API'
// types
import { SystemProcessObject } from 'types/graphql'

const RiskTemplateSystemProcesses: React.FC<{ riskTemplateId: string }> = ({ riskTemplateId }) => {
  const initialFilter = { objectId: riskTemplateId, objects: [SystemProcessObject.RiskTemplate] }

  return (
    <TableManagementProvider initialFilter={initialFilter}>
      <SystemProcessesPageAPI>
        <SystemProcesses />
      </SystemProcessesPageAPI>
    </TableManagementProvider>
  )
}

export default RiskTemplateSystemProcesses
